var $export = require('./_export');
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperty: require('./_object-dp').f });



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/es6.object.define-property.js
// module id = 37
// module chunks = 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 46 48 49 50 51 52 53 54 55 56 57 58 59 60 61 62 63 64 65 66 67 68